import type { CardProps } from '@/cms/Card';
import { Card } from '@/cms/Card';
import type { CmsExtraDataRecord } from '@/integrations/contentful';
import type { ContentType } from '@/integrations/contentful/types';

export type ItemData = CardProps | null;

export const renderCollectionItem = (
  data: ItemData,
  extraDataRecord?: CmsExtraDataRecord,
) => {
  const typename = data?.__typename as ContentType;
  const sysId = data?.sys?.id;
  const extraData = extraDataRecord ? extraDataRecord[sysId ?? ''] : undefined;

  switch (typename) {
    case 'Card':
      return (
        <Card
          {...(data as CardProps)}
          extraData={extraData?.extraData}
          mediaWrapperType='MyAccount12'
          type={data?.type || 'MyAccount'}
        />
      );

    default:
      return null;
  }
};
